<div class="container">
  <div class="contenedor-datos-basicos">

    <p class="title-approbe">
      Ingresa el código que te enviamos a tu celular para validar tu identidad
    </p>

    <div class="notice-otp">
      <p>Si estás tramitando tu crédito en sábado, domingo o festivo, el OTP llegará a tu correo electrónico registrado
        y no como mensaje de texto.</p>
    </div>

    <app-form [controls]="controlsOtp$ | async" (sendInfo)="getConfirmOtp($event)"></app-form>

    <p class="otp" (click)="enviarNuevoOtp()">Recibir otro código</p>

    <!-- <div *ngIf="mostrarError" class="contenedor-alerta-codigo-erroneo">
      <div class="contenedor-textos">
        <fa-icon [icon]="timesCircle"></fa-icon>
        <p>El código ingresado es incorrecto o está vencido, verifica e intenta de nuevo</p>
      </div>
    </div> -->

    <div *ngIf="mostrarNuevoCodigo" class="contenedor-alerta-nuevo-codigo">
      <fa-icon [icon]="checkCircle"></fa-icon>
      <p>Un nuevo código ha sido enviado por mensaje de texto a tu celular</p>
    </div>
  </div>
</div>